import { useAppSelector } from '../../../hooks';
import ErrorList from '../../ErrorList';

export default function Points() {
  const errorMessages = useAppSelector((s) => s.points.errorMessages);
  return (
    <div className="points">
      <h2>Punkty</h2>
      <ErrorList errorMessages={errorMessages} />
    </div>
  );
}
